module.exports = __webpack_public_path__ + "static/media/close.8c266a8f.svg";